import { Box, Button } from "@mui/material";
import styled from "styled-components";

export const ModalContantContainer = styled(Box)`
  max-width: 626px;
  display: flex;
  min-height: 420px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
`;

export const ModalTextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const ModalTitle = styled.h1`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 100%;
  text-align: center;
`;

export const ModalDescription = styled.p`
  font-weight: ${({ theme }) => theme.fontWeights.light};
  font-size: ${({ theme }) => theme.fontSizes.headings.h4};
  text-align: center;
`;

export const ModalButton = styled(Button)`
  &.MuiButton-root {
    background-color: ${({ theme }) => theme.palette.primary.secondaryBlue};
    color: ${({ theme }) => theme.palette.primary.white};
    font-size: ${({ theme }) => theme.fontSizes.body.l};
    font-variant-caps: normal;
    text-transform: none;
    border-radius: 0;
    box-shadow: none;
  }
`;
